import { useContext } from 'react';
import { VanityUrlContext } from '../components/vanity-urls';

export const useCurrentDomain = () => {
  const { parentDomain, isVanityDomain } = useContext(VanityUrlContext);

  const domain = window.location.hostname;
  return { parentDomain, isVanityDomain, domain };
};
